export enum RoleEnum {
  Public = "Public",
  Submitter = "Submitter",
  Administrator = "Administrator",
  Editor = "Editor",
  Reviewer = "Reviewer",
}
export default RoleEnum;
